import { gql } from '@apollo/client';

export const IS_USER_VERIFIED = gql`
  mutation VerifyUserInSmileCDR(
    $verifyUserInSmileRequest: VerifyUserInSmileRequest
  ) {
    verifyUserInSmileCdr(verifyUserInSmileRequest: $verifyUserInSmileRequest)
  }
`;

export const CREATE_ACCOUNT = gql`
  mutation createAccountMember($registerUserRequest: RegisterUserRequest) {
    createAccountMember(registerUserRequest: $registerUserRequest) {
      userId
      responseMessage
    }
  }
`;

export const GENERATE_OTP = gql`
  query generateOTPUnAuthMember($phone: String) {
    generateOTPUnAuthMember(phone: $phone) {
      verificationSid
      phoneVerificationStatus
    }
  }
`;

export const VALIDATE_OTP = gql`
  mutation validateOTPUnAuthMember(
    $validateOTPRequest: ValidateOTPRequest
    $userId: String
  ) {
    validateOTPUnAuthMember(
      validateOTPRequest: $validateOTPRequest
      userId: $userId
    ) {
      phoneVerificationStatus
    }
  }
`;

export const LOGIN_USER = gql`
  mutation login($loginRequest: LoginRequest) {
    login(loginRequest: $loginRequest) {
      access_token
      refresh_token
      userId
      phoneNumber
    }
  }
`;

export const PHONE_NUMBER_EXISTS = gql`
  mutation verifyUserInKeycloak($verifyUserRequest: VerifyUserRequest) {
    verifyUserInKeycloak(verifyUserRequest: $verifyUserRequest)
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ForgetMemberPassword($updatePasswordRequest: UpdatePasswordRequest) {
    forgetMemberPassword(updatePasswordRequest: $updatePasswordRequest)
  }
`;

export const VERIFY_USER_IN_KEYCLOAK = gql`
  mutation verifyUserInKeycloak($verifyUserRequest: VerifyUserRequest) {
    verifyUserInKeycloak(verifyUserRequest: $verifyUserRequest)
  }
`;

export const FETACH_ALL_ASSESSMENT_QUERY = gql`
  mutation getAssessments($assessmentRequest: AssessmentRequest) {
    getAssessments(assessmentRequest: $assessmentRequest) {
      assessmentList {
        assessmentMeta {
          id
          assessmentName
          status
          orgImageURL
          orgName
          numberOfQuestions
          assignedDate
          expiryDate
          completedDate
        }
        assessmentResponseBody {
          lastAnsweredIndex
        }
      }
      count
      __typename
    }
  }
`;
